import React, { useState } from 'react';
import axios from '../../../library/axios'
import { MySwal } from '../../../library/swal'
import Button from 'react-bootstrap/Button'
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const EditGroupComp = (props) => {
  // console.log(props);

  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [group, setGroup] = useState(props?.group?.namaGroup);
  const [checkedRead, setcheckedRead] = useState(
    props?.group?.access_groups[0]?.lihat === 2 ? true : false
  );
  const [checkedCreate, setcheckedCreate] = useState(
    props?.group?.access_groups[0]?.tulis === 2 ? true : false
  );
  const [checkedUpdate, setcheckedUpdate] = useState(
    props?.group?.access_groups[0]?.ubah === 2 ? true : false
  );
  const [checkedDelete, setcheckedDelete] = useState(
    props?.group?.access_groups[0]?.hapus === 2 ? true : false
  );
  const [checkedApproval, setcheckedApproval] = useState(
    props?.group?.access_groups[0]?.approval === 2 ? true : false
  );

  const handleUpdateGroup = () => {
    setLoading(true)
    setDisabled(true)

    const requestBody = {
      namaGroup: group
    }
    // console.log(requestBody)
    // return false
    axios({
      url: `/groups/update/${props?.group?.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then(res => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          handleUpdateAccessGroup(props?.group?.id)
        }
      })
      .catch(err => {
        setLoading(false)
        setDisabled(false)
        if (err !== "") {
          console.log(err?.response)
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.messages}`
          })
        }
      })
  }

  const handleUpdateAccessGroup = (idGroup) => {
    setLoading(true)
    setDisabled(true)

    const requestBody = {
      idGroup: idGroup,
      lihat: checkedRead === true ? 2 : 1,
      tulis: checkedCreate === true ? 2 : 1,
      ubah: checkedUpdate === true ? 2 : 1,
      hapus: checkedDelete === true ? 2 : 1,
      approval: checkedApproval === true ? 2 : 1,
    }
    // console.log(requestBody)
    // return false
    axios({
      url: `/access-groups/update/${props?.group?.access_groups[0]?.id}`,
      method: 'PATCH',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then(res => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully updated Groups!'
          })

          setLoading(false)
          setDisabled(false)

          props.close()
          props.fetch()
        }
      })
      .catch(err => {
        setLoading(false)
        setDisabled(false)
        if (err !== "") {
          console.log(err?.response?.data?.message)
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: `${err?.response?.data?.message}`
          })
        }
      })
  }

  return (
    <div>
      <div className="mb-3 row">
        <label htmlFor="group" className="col-sm-4 col-form-label">
          Nama Group
        </label>
        <div className="col-sm-12">
          <input
            type="text"
            className="form-control"
            id="group"
            onChange={(e) => setGroup(e.target.value)}
            value={group}
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="group" className="col-sm-4 col-form-label">
          <span className="badge badge-info">Fungsi Group</span>
        </label>
      </div>
      {/*begin::Checkboxes*/}
      <div className="d-flex align-items-center">
        {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          View
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={checkedRead}
            onClick={() => setcheckedRead(!checkedRead)}
          />
        </label>
        {/*end::Checkbox*/}
        {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Create
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={checkedCreate}
            onClick={() => setcheckedCreate(!checkedCreate)}
          />
        </label>
        {/*end::Checkbox*/} {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Edit
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={checkedUpdate}
            onClick={() => setcheckedUpdate(!checkedUpdate)}
          />
        </label>
        {/*end::Checkbox*/} {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Delete
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={checkedDelete}
            onClick={() => setcheckedDelete(!checkedDelete)}
          />
        </label>
        {/*end::Checkbox*/}
        {/*begin::Checkbox*/}
        <span className="form-check-label fw-bold text-center m-lg-2">
          Approval
        </span>
        <label className="form-check form-check-custom form-check-solid me-5">
          <input
            className="form-check-input h-20px w-20px"
            type="checkbox"
            checked={checkedApproval}
            onClick={() => setcheckedApproval(!checkedApproval)}
          />
        </label>
        {/*end::Checkbox*/}
      </div>
      {/*end::Checkboxes*/}
      <div className="mt-8 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button disabled={disabled} variant="success" size="sm" onClick={() => handleUpdateGroup()}>{loading === true ? 'Mohon Tunggu..' : 'Simpan'}</Button>
        </div>
      </div>
    </div>
  );
};

export default EditGroupComp;
